import { SimpleInvoice } from '@mews-commander/data-access';
import { renderInvoiceItem } from './renderInvoiceItem';

interface RenderInvoiceListProps {
    invoices: SimpleInvoice[];
}

export const renderInvoiceList = ({ invoices }: RenderInvoiceListProps) =>
    [...invoices.map((invoice) => renderInvoiceItem(invoice))].filter(Boolean);
